import { render, staticRenderFns } from "./CustomProgressBar.vue?vue&type=template&id=0cb31022&"
import script from "./CustomProgressBar.vue?vue&type=script&lang=ts&"
export * from "./CustomProgressBar.vue?vue&type=script&lang=ts&"
import style0 from "./CustomProgressBar.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VTooltip})
